import textAreaListener from '../../services/textAreaListener';

class Comment {
	constructor(root) {
		if (!root) return;
		this.root = root;
		this.reCaptchaKey = document.querySelector('[data-site]').dataset.site;
		this.parentContainer = this.root.closest('.comments');
		this.btnsContainer = this.root.querySelector('.comment__btns');
		this.controlsContainer = this.root.querySelector('.comment__controls');
		this.commentContent = this.root.querySelector('.comment__text');
		if (this.controlsContainer) this.adminControlContainer = this.controlsContainer.querySelector('details');

		this.answerBtn = this.root.querySelector('[data-type="answer"]');
		this.hideBtn = this.root.querySelector('[data-type="hide"]');
		this.editBtn = this.root.querySelector('[data-type="form"]');
		this.adminBtnsList = this.root.querySelectorAll('[data-type="direct"],[data-type="hide"]');
		this.toggleVisibleBtns = [this.editBtn, this.answerBtn, this.adminControlContainer, this.hideBtn];

		this.editBtnActualStatus = true;
		this.form;
		this.textArea;
		this.userName = this.root.querySelector('.user__name');
		this.editCommentErrorMsg = 'Время ожидания редактирования превысило 15 минут. По истечению этого времени редактировать комментарий нельзя.';

		this.addEvents();
	}

	addEvents() {
		this.answerBtn.addEventListener('click', this.openCommentWindow.bind(this));
		if (this.editBtn) {
			this.editBtn.addEventListener('click', this.editComment.bind(this));
		}
		if (this.adminBtnsList.length) {
			this.adminBtnsList.forEach((btn) => {
				btn.addEventListener('click', this.adminControl.bind(this));
			});
		}
	}

	openCommentWindow({ target }) {
		// блокируем кнопку от многократных нажатий
		this.answerBtn.disabled = true;

		// получаем APi url для формы
		const apiUrl = this.getApiUrl(target);
		// создаем форму
		this.renderForm(apiUrl);
		// добавляем ее в DOM
		this.btnsContainer.after(this.form);
		// Удаляем кнопку
		this.answerBtn.hidden = true;
		// Ставим фокус на форму и стили
		this.textArea.focus();
		textAreaListener(this.form);
		// Заполняем форму именем автора
		this.fillArea();
		// Вешаем слушатель
		this.form.addEventListener('submit', this.submitForm.bind(this));
	}

	renderForm(apiUrl) {
		const scrAvatarUrl = this.getAvatarUrl();
		const form = document.createElement('form');
		form.action = apiUrl;
		form.classList.add('comments__form', 'comments__form_answer');
		const imgAvatar = scrAvatarUrl ? `<img src= ${scrAvatarUrl} alt="Аватар"/>` : '';
		form.innerHTML = `
		<picture class="comments__form-img">
			${imgAvatar}
		</picture>
		<label class="comments__form-label">
			 <textarea class="comments__form-input" type="text" placeholder="Ответить" name="newAnswer" maxlength="2000" required="required"></textarea>
			<button class="comments__form-btn" type="submit">
				<svg width="16" height="16">
					<use xlink:href="#icon-submit"></use>
				</svg>
			</button>
		</label>
		`;
		this.form = form;
		this.textArea = this.form.querySelector('textarea');
	}

	removeForm() {
		// eslint-disable-next-line sonarjs/no-duplicate-string
		const form = this.root.querySelector('.comments__form_answer');
		if (form) form.remove();
	}

	// Заполняем в textarea обращение по именни создателя коммента
	fillArea() {
		const autorName = this.userName.firstChild.textContent.split('\n')[0];
		this.textArea.value = `${autorName}, `;
	}

	// получаем url аватара пользователя
	getAvatarUrl() {
		const urlUserAvatar = this.parentContainer.querySelector('.comments__form-img img');
		if (urlUserAvatar) {
			return urlUserAvatar.src;
		} else {
			return null;
		}
	}

	// получаем API url для POST запроса
	getApiUrl(selector) {
		const container = selector.closest('.comments__list');
		if (container) {
			return container.dataset.action;
		}
	}

	// получаем ID комментария
	getDatesId(selector) {
		const parent = selector.parentNode;
		if (selector.matches('.comments__form_answer')) {
			const id = parent.dataset.id;
			return { id };
		} else {
			const elementId = parent.dataset.element;
			const ownerId = parent.dataset.owner;
			return { elementId, ownerId };
		}
	}

	submitForm(e) {
		e.preventDefault();
		const form = e.target;
		const submitBtn = form.querySelector('button[type="submit"]');
		const input = form.querySelector('.comments__form-input');
		input.value = input.value.trim();

		if (input.value.length > 0) {
			submitBtn.disabled = true;
			const idDates = this.getDatesId(form);
			const formData = new FormData(form);
			for (const data in idDates) {
				formData.append(data, idDates[data]);
			}
			this.getToken(form.action, formData, form);
		}
	}

	// Проверка токена reCAPTCHA
	getToken(apiUrl, formData, form) {
		const grecaptcha = window.grecaptcha;
		grecaptcha.ready(() => {
			grecaptcha.execute(this.reCaptchaKey, { action: 'submit' }).then((token) => {
				formData.append('token', token);
				this.fetch(apiUrl, formData, form);
			});
		});
	}

	// POST запрос
	async fetch(url, formData, form) {
		try {
			const response = await fetch(url, {
				method: 'POST',
				body: formData,
			});

			const result = await response?.json();
			if (response.status !== 200) {
				this.renderErrorPopup(form, result.message);
			} else {
				this.renderNewComment(result, form);
			}
		} catch (err) {
			console.log('Error ', err);
		} finally {
			const submitBtn = form.querySelector('button[type="submit"]');
			submitBtn.disabled = false;
		}
	}
	// Получаем ul в который будем закидывать новый комментарий или подкомментарий или запускам рендер нового
	getParentForComment(form) {
		const parent = form.parentNode;
		if (parent.matches('.comments')) {
			return this.getUlForComments(parent);
		} else {
			return this.getUlForSubComments(parent);
		}
	}

	// Получаем или рендорим новый ul для комментария
	getUlForComments(parent) {
		if (parent.querySelector('ul')) {
			return parent.querySelector('ul');
		} else {
			return this.renderUlForComment();
		}
	}

	// Получаем или рендорим новый ul для подкомментария(если ответ "второго уровня", возращаем ul родителя)
	getUlForSubComments(parent) {
		// eslint-disable-next-line sonarjs/no-duplicate-string
		if (parent.closest('.comment__details')) {
			return parent.closest('ul');
		} else {
			if (parent.querySelector('.comment__details')) {
				return parent.querySelector('.comment__details ul');
			} else {
				return this.renderDetailsForComment();
			}
		}
	}

	// создаем новый ul если у "темы" вообще нет комментариев
	renderUlForComment() {
		const newParent = document.createElement('ul');
		newParent.classList.add('comments__list');
		this.root.append(newParent);
		return newParent;
	}

	// Создаем новый details если у комментария нет подкомментариев
	renderDetailsForComment() {
		const newParent = document.createElement('details');
		newParent.setAttribute('open', 'true');
		newParent.classList.add('comment__details');
		newParent.innerHTML = `
														<summary class="comment__summary">1 ответ
															<svg width="16" height="16">
																<use xlink:href="#comment-answer"></use>
															</svg>
														</summary>
														<ul class="comments__list comments__list_answers" data-action="/api/comments/reply/">
														</ul>
													`;
		this.root.append(newParent);
		return newParent.querySelector('ul');
	}

	// открываем details и обновляем счетчик подкомментариев
	editDetails(details) {
		!details.open ? (details.open = true) : '';
		// Доделать!
		// this.editSubCommentsLength();
	}

	// Обновляем общий счеткик комментариев
	editCommentsLength() {
		const commentsBlock = this.root.matches('.comments') ? this.root : this.root.closest('.comments');
		let span = commentsBlock.querySelector('.comments__title span');
		const newLength = Number(span.textContent.replace(/\D/g, '')) + 1;
		span.textContent = `(${newLength})`;
	}
	// создаем новый комментарий и закидыываем его в конец списка
	renderNewComment(data, form) {
		if (data) {
			// отрисовываем контейнер для родителя
			const commentsList = this.getParentForComment(form);

			// отрисовываем коммент
			const newComment = document.createElement('div');
			newComment.classList.add('comment');
			newComment.dataset.id = data.id;

			const imgAvatar = data.avatarUrl ? `<img src= ${data.avatarUrl} alt="Аватар"/>` : '';
			newComment.innerHTML = `
													<div class="user">
														<picture class="user__avatar">${imgAvatar}</picture>
													<p class="user__name">${data.userName}</p>
													<div class="user__data">
														<time datetime= ${data.date}>${data.date}</time>
														<time datetime= ${data.time}>, ${data.time}</time>
													</div>
												</div>
												<p class="comment__text">${data.text}</p>
												<div class="comment__btns">
													<div class="comment__answer">
														<button class="comment__btn" type="sumbit" data-type="answer" aria-label="Ответить">Ответить</button>
													</div>
													<div class="comment__controls">
													</div>
												</div>
												`;
			commentsList.prepend(newComment);
			if (data.adminControls) {
				this.renderButtonsControl(newComment, data.adminControls);
			}
			new Comment(newComment);
			if (form.matches('.comments__form_answer')) {
				this.removeForm();
				const details = this.root.querySelector('.comment__details') ? this.root.querySelector('.comment__details') : this.root.closest('.comment__details');
				this.editDetails(details);
				this.answerBtn.hidden = '';
				this.answerBtn.disabled = false;
			} else {
				form.reset();
				const btnSubmit = form.querySelector('.comments__form-btn');
				btnSubmit.disabled = false;
				btnSubmit.classList.remove('comments__form-btn_active');
			}
			newComment.scrollIntoView({ block: 'center', behavior: 'smooth' });
			this.editCommentsLength();
		}
	}

	renderButtonsControl(comment, buttonsArr) {
		const commentControl = comment.querySelector('.comment__controls');
		buttonsArr.forEach((btn) => {
			if (btn.type === 'direct') {
				const buttonsUl = commentControl.querySelector('ul');
				if (buttonsUl) {
					buttonsUl.append(this.renderNewButton(btn));
				} else {
					const details = document.createElement('details');
					details.innerHTML =
						'<summary><span><svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="1" cy="1" r="1" fill="#565C68"></circle></svg></span><span><svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="1" cy="1" r="1" fill="#565C68"></circle></svg></span><span><svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="1" cy="1" r="1" fill="#565C68"></circle></svg></span></summary><ul></ul>';
					commentControl.append(details);
					commentControl.querySelector('ul').append(this.renderNewButton(btn));
				}
			} else {
				commentControl.append(this.renderNewButton(btn));
			}
		});
	}

	// Управление кнопками админа
	async adminControl(data) {
		const target = data.nodeName ? data : data.target;
		const apiUrl = target.dataset.api;
		let formData;
		if (target === this.editBtn) {
			formData = new FormData();
			formData.append('text', this.commentContent.textContent);
		}
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				body: formData,
			});
			const result = await response.json();

			if (response.status !== 200) {
				this.renderErrorPopup(this.btnsContainer, this.editCommentErrorMsg);
				this.editBtn.remove();
			} else {
				const { isVisible, adminControls } = result;
				if (target.dataset.type === 'hide') {
					isVisible ? this.root.classList.remove('comment__hidden') : this.root.classList.add('comment__hidden');
				}
				if (target.dataset.type === 'form') {
					this.commentContent.textContent = result.text;
				}
				const actualBtn = adminControls.find((btn) => btn.url === apiUrl);
				target.textContent = actualBtn.name;
			}
		} catch (err) {
			console.log('Error ', err);
		}
	}

	// Редактирование коммента
	editComment() {
		this.commentContent.setAttribute('contenteditable', 'true');
		// eslint-disable-next-line sonarjs/no-duplicate-string
		this.commentContent.setAttribute('aria-label', 'Форма для редактирования комментария');
		this.commentContent.focus();
		this.renderControlEditBtns(this.controlsContainer);
		this.hideBtns(this.toggleVisibleBtns);
	}

	hideBtns(btnList) {
		btnList.forEach((btn) => {
			if (btn) btn?.setAttribute('style', 'display:none');
		});
	}

	showBtns(btnList) {
		btnList.forEach((btn) => {
			btn?.removeAttribute('style');
		});
	}

	renderNewButton(btnParam) {
		const btn = document.createElement('button');
		btn.classList.add('comment__btn');
		btn.setAttribute('type', 'button');
		btn.setAttribute('data-type', btnParam.type);
		btn.setAttribute('data-api', btnParam.url);
		btn.setAttribute('aria-label', btnParam.name);
		btn.innerHTML = btnParam.name;
		return btn;
	}

	renderControlEditBtns(container) {
		const btnsParam = [
			{ type: 'cancel', name: 'Отменить редактирование' },
			{ type: 'save', name: 'Сохранить' },
		];
		btnsParam.forEach((param) => {
			const newEditBtn = this.renderNewButton(param);
			container.prepend(newEditBtn);
			newEditBtn.addEventListener('click', this.controlEditComment.bind(this));
		});
	}

	controlEditComment({ target }) {
		if (target.dataset.type === 'save') {
			this.saveEditComment();
		}
		const editControlsBtns = this.root.querySelectorAll('[data-type="save"], [data-type="cancel"]');
		this.commentContent.removeAttribute('contenteditable');
		this.commentContent.removeAttribute('aria-label');
		editControlsBtns.forEach((btn) => btn.remove());
		this.showBtns(this.toggleVisibleBtns);
	}

	saveEditComment() {
		if (this.editBtnActualStatus) {
			this.adminControl(this.editBtn);
		} else {
			this.renderErrorPopup(this.btnsContainer, this.editCommentErrorMsg);
			this.editBtn.remove();
		}
	}

	renderErrorPopup(parent, message) {
		const popup = document.createElement('div');
		popup.classList.add('show-message');
		popup.innerHTML = message;
		parent.prepend(popup);
		this.timeout = setTimeout(() => {
			popup.remove();
		}, 4000);
	}
}

export default Comment;
